(ns portal.role-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            [cljs-bean.core :refer [->clj]]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-query]]
            [common.resource.query.advertiser :as advertiser.q]
            [common.util :refer [spread-obj]]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [portal.role-ocp.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal confirm-delete :role/confirm-delete
  [name]
  [deletion-confirmation
   {:on-submit #(rf/dispatch [:role-ocp.db/delete-role])
    :item-label name
    :entity-name "role"}])

(defui ocp-footer
  [{:keys [mode]}]
  (let [{:keys [name]} (use-subscribe [:role-ocp.db/value []])]
    ($ :<>
       (when (= :edit mode)
         ($ Button
            {:variant "contained"
             :color "error"
             :onClick #(rf/dispatch [:modal/open {:id :role/confirm-delete
                                                  :props name}])
             :data-testid "delete-role-button"}
            "Delete role"))
       ($ Button
          {:variant "contained"
           :type "submit"
           :data-testid (str (if (= :create mode) "create" "save") "-role-button")}
          (if (= :create mode)
            "Create role"
            "Save role")))))

(defn get-advertiser-options [^js data]
  (->> (->clj data)
       (mapv (fn [advertiser]
               {:label (:name advertiser)
                :value (:id advertiser)}))))

(defocp role-ocp :role/crud [{:keys [role reload]}]
  (uix/use-effect (fn []
                    (rf/dispatch [:role-ocp.db/init-form role reload])
                    (fn []
                      (rf/dispatch [:role-ocp.db/destroy])))
                  [role reload])
  (let [mode (use-subscribe [:role-ocp.db/mode])
        {advertiser-options :data} (use-query (spread-obj (advertiser.q/advertisers-query)
                                                          #js {:select get-advertiser-options}))]
    ($ ocp
       {:title (if (= :create mode)
                 "Create a new role"
                 "Edit role")
        :on-submit #(rf/dispatch [:role-ocp.db/submit])
        :footer ($ ocp-footer {:mode mode})}
       ($ form-field
          {:label "Role name"
           :err-msg (form/use-error-message [:name])}
          ($ input
             (merge (form/use-bind-control [:name])
                    {:type "text"
                     :data-testid "role-name-input"})))
       ($ form-field
          {:label "Management"}
          ($ Stack
             ($ checkbox
                (merge (form/use-bind-control [:permissions :management :useraccounts]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "User & roles"
                        :id :useraccounts
                        :disabled? (use-subscribe [:role-ocp.db/users-and-roles-disabled?])}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :management :adservers]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Adservers"
                        :id :adservers}))))
       ($ form-field
          {:label "Advertisers"}
          ($ Stack
             ($ checkbox
                (merge (form/use-bind-control [:permissions :advertisers :edit]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Edit"
                        :id :advertisers-edit
                        :disabled? (use-subscribe [:role-ocp.db/advertiser-checkbox-disabled?])}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :advertisers :create+delete]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Create/delete"
                        :id :advertisers-create+delete
                        :disabled? (use-subscribe [:role-ocp.db/advertiser-checkbox-disabled?])}))))
       ($ form-field
          {:label "Limit to advertiser(s)"}
          (r/as-element
           [dropdown (merge (form/use-bind-control [:advertiserIds])
                            {:options advertiser-options
                             :clearable? true
                             :multi? true
                             :data-testid "limit-advertiser-select"
                             :disabled? (use-subscribe [:role-ocp.db/limit-to-advertisers-disabled?])})]))
       ($ form-field
          {:label "Campaigns"}
          ($ Stack
             ($ checkbox
                (merge (form/use-bind-control [:permissions :campaigns :view]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "View"
                        :id :campaigns-view}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :campaigns :edit]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Edit"
                        :id :campaigns-edit}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :campaigns :create+delete]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Create/delete"
                        :id :campaigns-create+delete}))))
       ($ form-field
          {:label "Adsets"}
          ($ Stack
             ($ checkbox
                (merge (form/use-bind-control [:permissions :adsets :view]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "View"
                        :id :adsets-view}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :adsets :edit]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Edit"
                        :id :adsets-edit}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :adsets :create+delete]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Create/delete"
                        :id :adsets-create+delete}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :adsets :content]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Configure content"
                        :id :adsets-content}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :adsets :trackers]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Configure trackers"
                        :id :adsets-trackers}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :adsets :templates]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Manage templates"
                        :id :adsets-templates}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :adsets :export]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Export"
                        :id :adsets-export}))))
       ($ form-field
          {:label "Templates"}
          ($ Stack
             ($ checkbox
                (merge (form/use-bind-control [:permissions :templates :view]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "View"
                        :id :templates-view}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :templates :edit]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Edit"
                        :id :templates-edit}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :templates :create+delete]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Create/delete"
                        :id :templates-create+delete}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :templates :limit]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Limit to created by user"
                        :id :templates-limit}))))
       ($ form-field
          {:label "Products"}
          ($ Stack
             ($ checkbox
                (merge (form/use-bind-control [:permissions :products :view]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "View"
                        :id :products-view}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :products :edit]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Edit"
                        :id :products-edit}))
             ($ checkbox
                (merge (form/use-bind-control [:permissions :products :configure]
                                              {:on-change-event :role-ocp.db/on-change-permission})
                       {:label "Configure store"
                        :id :products-configure})))))))
